module.exports = __webpack_public_path__ + "static/media/m-1-06.e6cb35bb.svg";